import { render, staticRenderFns } from "./authorization_two.vue?vue&type=template&id=ba4a4696&scoped=true&"
import script from "./authorization_two.vue?vue&type=script&lang=js&"
export * from "./authorization_two.vue?vue&type=script&lang=js&"
import style0 from "./authorization_two.vue?vue&type=style&index=0&id=ba4a4696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4a4696",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
